<template>
  <v-form>
    <h2 class="text-center mb-4">Let's setup your store</h2>
    <v-row class="mb-4">
      <v-col cols="12" md="6" class="pb-0"
        ><label class="font-weight-medium"> Choose your new domain </label>
        <p class="mb-0 grey--text" style="font-size: 14px">Enter the domain you want to connect</p></v-col
      >
      <v-col cols="12" md="6">
        <v-text-field
          autocomplete="off"
          placeholder="e.g. example.com"
          append-icon="mdi-help-circle-outline"
          class="store-domain-input"
          v-model.trim="form.storeDomain"
          :error-messages="errorMessageStoreDomain"
          @blur="validateDomain"
          @change="onSaveDomain"
          @click:append="domainTutorialDialog = true"
        ></v-text-field>
        <p v-if="isDomainReady && isDomain(form.storeDomain)" class="mb-0 success--text">
          <i class="mdi mdi-check-circle-outline mr-1"></i>Ready to use
        </p>
      </v-col>
    </v-row>
    <v-row class="mb-4">
      <v-col cols="12" md="6" class="pb-0">
        <label class="font-weight-medium"> Logo </label>
        <p class="mb-0 grey--text" style="font-size: 14px">Upload your store's logo</p>
      </v-col>
      <v-col cols="12" md="6">
        <div>
          <v-radio-group v-model="logoOption" row>
            <v-radio label="Use default logo" value="default"></v-radio>
            <v-radio label="Upload custom logo" value="upload"></v-radio>
          </v-radio-group>
        </div>
        <div v-show="logoOption === 'upload'">
          <UploadOneImage :image="form.favicon" @callback="getImageUpLoad" />
        </div>
        <div v-show="logoOption === 'default'">
          <GenerateLogo :name="nameLogo" @update:name="nameLogo = $event" @update:outputImage="outputImage = $event" />
        </div>
      </v-col>
    </v-row>
    <v-row class="mb-4">
      <v-col cols="12" md="6">
        <label class="font-weight-medium"> Business type</label>
        <p class="mb-0 grey--text" style="font-size: 14px">Choose business type for your store</p>
      </v-col>
      <v-col cols="12" md="6">
        <v-chip-group v-model="businessType" color="primary" mandatory>
          <v-chip v-for="(businessType, index) in businessTypes" :key="index" :value="businessType.code" label>
            {{ businessType.title }}
          </v-chip>
        </v-chip-group>
      </v-col>
    </v-row>
    <v-row class="mb-4">
      <v-col cols="12" md="12">
        <label class="font-weight-medium"> Theme</label>
        <p class="mb-0 grey--text" style="font-size: 14px">Choose theme for your store</p>
      </v-col>
      <v-col cols="12" md="12">
        <ul class="list-theme">
          <li
            v-for="(item, index) in themes"
            :key="index"
            :class="{ actived: form.theme === item.value }"
            @click="form.theme = item.value"
          >
            <div class="image-wrapper mb-3">
              <img :src="item.image" :alt="item.value" />
            </div>
            <v-dialog>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" :color="form.theme === item.value ? 'primary' : ''" block depressed
                  >{{ item.name }}
                </v-btn>
              </template>

              <v-card>
                <div class="px-3 image-preview">
                  <img :src="item.image" :alt="item.value" />
                </div>
              </v-card>
            </v-dialog>
          </li>
        </ul>
      </v-col>
    </v-row>
    <!-- <v-row class="mb-4">
      <v-col cols="12" md="6" class="pb-0">
        <label class="font-weight-medium"> Theme Store </label>
        <p class="mb-0 grey--text" style="font-size: 14px">Choose theme for your store</p>
      </v-col>

      <v-col cols="12" md="6">
        <v-row dense>
          <v-col cols="6">
            <v-btn width="100%" depressed :color="form.theme == 3 ? 'primary' : 'default'" @click="form.theme = 3"
              >Green Health
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn width="100%" depressed :color="form.theme == 4 ? 'primary' : 'default'" @click="form.theme = 4">
              Blue Tech
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn width="100%" depressed :color="form.theme == 5 ? 'primary' : 'default'" @click="form.theme = 5">
              Mint Shop
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn width="100%" depressed :color="form.theme == 6 ? 'primary' : 'default'" @click="form.theme = 6">
              Vegashine
            </v-btn>
          </v-col>
        </v-row>
        <ul class="list-theme">
          <li @click="form.theme = 3" v-if="form.theme === 3" :class="{ actived: form.theme === 3 }">
            <div class="image-wrapper">
              <img
                src="https://minio.dropnoxe.com/img/400/500/resize/static/21-07-2023/2.png"
                alt="Green Health Theme"
              />
            </div>
          </li>
          <li v-if="form.theme === 4" @click="form.theme = 4" :class="{ actived: form.theme === 4 }">
            <div class="image-wrapper">
              <img src="https://minio.dropnoxe.com/img/400/500/resize/static/21-07-2023/1.png" alt="Blue Tech Theme" />
            </div>
          </li>
          <li v-if="form.theme === 5" @click="form.theme = 5" :class="{ actived: form.theme === 5 }">
            <div class="image-wrapper">
              <img src="@/assets/images/mint-shop.png" alt="Mint Shop" />
            </div>
          </li>
          <li v-if="form.theme === 6" @click="form.theme = 5" :class="{ actived: form.theme === 5 }">
            <div class="image-wrapper">
              <img src="@/assets/images/vegashine-theme.png" alt="Vegashine" />
            </div>
          </li>
        </ul>
      </v-col>
    </v-row> -->
    <div class="d-flex justify-end">
      <v-btn color="primary" :loading="isLoading" @click="nextStep"> Next </v-btn>
    </div>
    <v-dialog v-model="domainTutorialDialog" width="500">
      <v-card>
        <v-card-title class="text-h5"> Help (Hướng dẫn) </v-card-title>
        <v-card-text>
          <p class="mb-2">Cửa hàng trực tuyến của bạn cần có một tên miền để khách hàng có thể truy cập được.</p>
          <ul class="mb-4">
            <li>
              <strong>Nếu bạn chưa có domain:</strong> hãy điền domain phù hợp, chúng tôi sẽ mua và gắn vào cửa hàng.
              *Nhớ kiểm tra domain còn mua được không
            </li>
            <li>
              <strong>Nếu bạn đã có sẵn tên miền:</strong> để trống tên miền và nhắn đội hỗ trợ qua nick Telegram
              @dropnoxe_tech để được hỗ trợ sẽ giúp bạn gắn tên miền vào cửa hàng.
            </li>
          </ul>
          <p class="mb-2">Your online store needs a domain that helps your customers access it.</p>
          <ul>
            <li>
              <strong>If you do not own a domain:</strong> Please think of a name that represents your store and make
              sure that the domain is still available via namecheap.com*. Then we will help you buy and add the domain
              to your store.
            </li>
            <li>
              <strong>If you already own a domain:</strong> and want to transfer it to dropnoxe, please contact our
              support via Telegram account @dropnoxe_tech, we will help you to connect that domain to your store.
            </li>
          </ul>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="domainTutorialDialog = false"> Okay </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import { domainService } from '@/apis/domain.s';
import { uploadService } from '@/apis/upload.s';
import { extractDomainName } from '@/helpers/utilities';
import axios from 'axios';
import GenerateLogo from './generate-logo';
import { ALL_THEMES, getThemeByValue } from '../../../const/themes';
export default {
  components: {
    GenerateLogo,
  },
  props: {
    callback: {
      type: Function,
      default(data) {},
    },
  },
  data() {
    return {
      form: {
        storeDomain: null,
        favicon: { src: '', position: 1 },
        theme: 8,
      },
      outputImage: '',
      logoOption: 'default',
      nameLogo: (localStorage.getItem('defaultSystemDomain') || '').split('.')[0],
      isLoading: false,
      isValidDomain: true,
      errorMessageStoreDomain: null,
      domainTutorialDialog: false,
      isDomainReady: false,
      businessTypes: [
        { title: 'Dropshiping', code: 'dropship' },
        { title: 'Print on demand', code: 'pod' },
      ],
      businessType: 'dropship',
      checkOutStyles: ALL_THEMES,
    };
  },
  watch: {
    businessType: {
      handler() {
        if (this.businessType === 'pod') {
          this.form.theme = 101;
        } else {
          this.form.theme = 8;
        }
      },
    },
    form: {
      handler(value) {
        const domainDefaulte = extractDomainName(localStorage.getItem('defaultSystemDomain'));
        if (this.form.storeDomain) {
          this.nameLogo = extractDomainName(this.form.storeDomain);
        } else {
          this.nameLogo = domainDefaulte;
        }
      },
      deep: true,
    },
  },
  computed: {
    themes() {
      return this.checkOutStyles.filter(item => item.type === this.businessType);
    },
  },
  methods: {
    getImageUpLoad(image) {
      this.form.favicon = image;
      this.$forceUpdate();
    },
    isDomain(domain) {
      if (!domain) return false;
      const regex = /(?:[\w-]+\.)+[\w-]+/;
      return regex.test(domain);
    },
    validateDomain() {
      if (!this.form.storeDomain) {
        this.isValidDomain = true;
        this.isDomainReady = true;
      } else {
        this.isValidDomain = this.isDomain(this.form.storeDomain);
        if (!this.isValidDomain) {
          this.errorMessageStoreDomain = 'Your domain is not valid';
          this.isDomainReady = false;
        }
      }
    },
    async nextStep() {
      try {
        this.isLoading = true;
        this.validateDomain();
        if (this.isValidDomain && this.isDomainReady) {
          let favicon = { ...this.form.favicon };
          if (this.logoOption === 'default' && this.outputImage) {
            favicon.src = this.outputImage;
            const blob = await fetch(this.outputImage).then(res => res.blob());
            const file = new File([blob], `logo-${Date.now()}.png`, { type: 'image/png' });
            let urlData = await uploadService.get({ filename: `image-${Date.now()}.png` });
            if (urlData) {
              let res = await axios.put(urlData.data.presignedUrl, file, {
                headers: {
                  'Content-Type': `${file.type}`,
                },
              });
              favicon.src = urlData.data.imagePath;
            }
          }
          this.callback({
            ...this.form,
            businessType: this.businessType,
            favicon,
            checkoutTheme: getThemeByValue(this.form.theme),
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }

      // console.log(this.form, this.businessType);
    },
    skipStep() {
      this.callback({
        storeDomain: null,
        favicon: { src: '', position: 1 },
        theme: 8,
        checkoutTheme: getThemeByValue(8),
      });
    },
    async onSaveDomain() {
      this.validateDomain();
      if (this.form.storeDomain && this.isValidDomain)
        try {
          this.isLoading = true;
          const storeId = localStorage.getItem('store-id') || '';
          const { data } = await domainService.checkDomain(this.form.storeDomain, storeId);
          if (data?.status) {
            this.errorMessageStoreDomain = null;
            this.isDomainReady = true;
          } else {
            this.isValidDomain = false;
            this.isDomainReady = false;
            this.errorMessageStoreDomain = data.msg;
          }
        } catch (error) {
          console.log('Error: ', error);
        } finally {
          this.isLoading = false;
        }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';

ul.list-theme {
  padding-left: 0;
  margin-top: 12px;
  list-style: none;
  gap: 16px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  @media screen and (min-width: 768px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  li {
    display: block;
    cursor: pointer;
    .image-wrapper {
      position: relative;
      border: solid 1px #e8e8e8;
      border-radius: 4px;
      overflow: hidden;
      height: 250px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fafafa;
      img {
        display: block;
        width: 100%;
        height: 100%;
        max-width: 400px;
        object-fit: contain;
      }
    }
    p {
      font-weight: 500;
      font-size: 16px;
      padding: 4px 0;
      margin: 0;
      color: #9e9e9e;
    }
    &.actived {
      .image-wrapper {
        background-color: var(--v-primary-base);
        border-color: var(--v-primary-base);
      }
      p {
        color: var(--v-primary-base);
      }
    }
  }
}

.image-preview {
  width: 100%;
  img {
    object-fit: contain;
    width: 100%;
  }
}

::v-deep .store-domain-input {
  .v-input__append-inner {
    margin-top: 9px;
    margin-right: 6px;
  }
}
::v-deep .v-slide-item--active {
  background-color: var(--v-primary-base);
  color: white;
}
</style>
